import React, { Component } from "react";
// import { Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import CircularProgress from '@material-ui/core/CircularProgress';
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Email from "@material-ui/icons/Email";
import AssignmentInd from "@material-ui/icons/AssignmentInd";

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import SmartInput from 'react-phone-number-input/smart-input';

// core components
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Button from "../../components/CustomButton";
import Card from "../../components/Card";
import CardHeader from "../../components/CardHeader";
import CardBody from "../../components/CardBody";
import CardFooter from "../../components/CardFooter";
import CustomInput from "../../components/CustomInput";
import CustomSnackBar from "../../components/CustomSnackBar";
// import Alert from '@material-ui/lab/Alert';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
import { NoSsr } from "@material-ui/core";
import ReactSelect from 'react-select';

import Header from "../../components/Retail/Header/Header";

// import MaterialButton from "@material-ui/core/Button";
// import Dialog from '@material-ui/core/Dialog';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle'
// import TermOfUse from '../TermsOfUse';

import loginPageStyle from "./registerPageStyle";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";

import AuthService from "../../services/api/AuthService";
import classNames from "classnames";
import moment from "moment";
import Home from "@material-ui/icons/Home";

// const dataSiteKey = "6Lemhl4aAAAAAHmvfl2U7EppXglrsyPaV_pswFIW";
const location = 'registerPage';
let locationString = '';
class RegisterPage extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            // Login, Change Password, Reset Password or Forgot Password
            componentMode: this.props.componentMode,
            cardAnimaton: "cardHidden",
            fullname: "",
            username: "",
            password: "",
            newPassword: "",
            confirmNewPassword: "",
            tr: false,
            redirectToReferrer: false,
            errorMessage: "",
            loading: false,
            disableSubmitButton: true,
            openTermOfUse: false,
            termSigned: false,
            newSession: false,
            isErrorMessage: true,
            message: '',
            resetForgottenPasswordValid: true,
            changedForgottenPassword: false,
            userSalutation: 'mr',

            noNRIC: false, 
            usernameError: false,
            usernameSuccess: false,
            emailError: false,
            emailSuccess: false,
            dateOfBirth: null,
            sameAddress: false, 
        };
        this.login = this.login.bind(this);
        this.register = this.register.bind(this);
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        this.timer = null;
        this.generateString();
        this.isAuthenticated();
        this.getAllBroker();
        this.getAllIncomeRange();
        window.addEventListener("visibilitychange", this.checkCookies);
        window.addEventListener("focus", this.checkCookies);
        window.addEventListener("blur", this.checkCookies);
        window.addEventListener('storage', this.checkLocalStorage);
        if (this.state.componentMode === 'resetForgottenPassword') {
            if (this.props.location.search.split('?token=')[1]) {
                this.setState({ passwordResetToken: this.props.location.search.split('?token=')[1] }, () => {
                    this.generateString();
                    // check token validity, set resetForgottenPasswordValid to false if token is not valid
                    this.authService.validateResetPasswordToken(this.state.passwordResetToken, location, locationString)
                        .then(res => {
                            this.setState({ loading: false, resetForgottenPasswordValid: true });
                        })
                        .catch(err => {
                            this.setState({
                                loading: false,
                                errorMessage: err.response.status === 429 ? 'An unexpected error occurred. Please try again later.' : err.response.data.content,
                                resetForgottenPasswordValid: false
                            });
                        });
                });
            } else {
                window.location.replace('/');
            }
        }
        else if (this.state.componentMode === 'forgotPassword') {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js";
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
            
            const script2 = document.createElement("script");
            script2.defer = true;
            script2.innerHTML = `var onloadCallback = function(response) {
                document.getElementById("grecaptcharesponse").value = response;
            };`
            // document.getElementById("grecaptcharesponse").setAttribute('value', response);
            document.body.appendChild(script2);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("visibilitychange", this.checkCookies);
        window.removeEventListener("focus", this.checkCookies);
        window.removeEventListener("blur", this.checkCookies);
        window.removeEventListener('storage', this.checkLocalStorage);
    }
    checkCookies = () => {
        const { setCookiesChanged } = this.props;
        setCookiesChanged();
    }
    checkLocalStorage = (event) => {
        if (window.localStorage.getItem('logout-event'))
            window.location.reload();
    }
    setLocalStorage = () => {
        window.localStorage.setItem('logout-event', 'false');
    }
    isAuthenticated() {
        this.authService.isAuthenticated(location, locationString)
            .then(res => {
                if (res && res.data) 
                    this.setState({ redirectToReferrer: true });
            });
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.username !== this.state.username || prevState.password !== this.state.password ||
            prevState.newPassword !== this.state.newPassword || prevState.confirmNewPassword !== this.state.confirmNewPassword
        ) {
            this.disableSubmitButton();
        }
        if (this.state.componentMode === 'register') {
            if (prevState.termsOfUse !== this.state.termsOfUse || prevState.privacyTerms !== this.state.privacyTerms)
                this.disableSubmitButton();
        }
    }
    getAllBroker = () => {
        this.authService.getAllBroker(location, locationString)
            .then(res => {
                if (res && res.data && !res.data.msg) {
                    let result = res.data.map(broker => {
                        return {
                            label: broker.participantName,
                            value: broker.dbtEntityId
                        }
                    });
                    this.setState({ allBroker: result });
                }
            })
    }
    getAllIncomeRange = () => {
        this.authService.getAllIncomeRange(location, locationString)
            .then(res => {
                if (res && res.data && !res.data.msg) {
                    let result = res.data.map(income => {
                        return {
                            label: income.incomeRange,
                            value: income.id
                        }
                    });
                    this.setState({ allIncomeRange: result });
                }
            })
    }
    login(e) {
        // this.setState({ loading: true });
        if (e)
            e.preventDefault();
        const { componentMode, username, password, newPassword, confirmNewPassword, termSigned, newSession } = this.state;

        this.generateString();
        if (componentMode === 'login') {
            if (username !== "" && password !== "") {
                const credential = {
                    username: username,
                    password: password,
                    newSession: newSession,
                };
                this.authService.login(credential, location, locationString)
                    .then(res => {
                        this.setState({ redirectToReferrer: true, loading: false, profileRedirect: res.data }, this.setLocalStorage);
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.setState({ loading: false });
                            this.setState({ errorMessage: "Invalid Credential!" })
                            this.showErrorMessage("tr");
                        } else if (err.response.status === 403) {
                            if (err.response.data) {
                                if (err.response.data.code === 'AC01') {
                                    this.setState({ componentMode: 'signTermAndResetPassword', loading: false, openTermOfUse: true });
                                } else if (err.response.data.code === 'AC02') {
                                    this.setState({ componentMode: 'resetPassword', loading: false });
                                } else if (err.response.data.code === 'AC03') {
                                    this.setState({ componentMode: 'signTermOfUse', loading: false, openTermOfUse: true });
                                } else if (err.response.data.code === 'AC04') {
                                    // this.setState({ loading: false, errorMessage: "Account is already being used right now" });
                                    // this.showErrorMessage("tr");
                                    this.setState({ loading: false, errorDialog: true });
                                } else if (err.response.data.code === 'AC05') {
                                    this.setState({ loading: false, errorMessage: "Account Expired" });
                                    this.showErrorMessage("tr");
                                }
                            }
                        }
                    });
            } else {
                this.setState({ loading: false });
                this.setState({ errorMessage: "Please fill in username and password!" })
                this.showErrorMessage("tr");
            }
        } else if (componentMode === 'changePassword') {
            if (password !== "" && newPassword !== "" && confirmNewPassword !== "") {
                if (password === newPassword) {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Please Make Sure Your Current Password and New Password Are Different!" })
                    this.showErrorMessage("tr");
                } else {
                    if (newPassword.length < 8) {
                        this.setState({ loading: false });
                        this.setState({ errorMessage: "Please make sure Your new password is at least 8 characters long" })
                        this.showErrorMessage("tr");
                    } else if (newPassword !== confirmNewPassword) {
                        this.setState({ loading: false });
                        this.setState({ errorMessage: "Passwords do not match" })
                        this.showErrorMessage("tr");
                    } else {
                        const credential = {
                            newPassword: newPassword,
                            oldPassword: password
                        };
                        this.authService.changePassword(credential, location, locationString)
                            .then(res => {
                                if (res && res.data && res.data.content) {
                                    if (res.data.content === 'OK')
                                        this.setState({ redirectToReferrer: true, loading: false });
                                    else {
                                        this.setState({ loading: false });
                                        this.setState({ errorMessage: res.data.content })
                                        this.showErrorMessage("tr");
                                    }
                                }
                            });
                    }
                }
            } else {
                this.setState({ loading: false });
                this.setState({ errorMessage: "Please fill in Current Password and New Password Correctly!" })
                this.showErrorMessage("tr");
            }
        } else if (componentMode === 'resetPassword') {
            if (username !== "" && password !== "" && newPassword !== "" && confirmNewPassword !== "" && newPassword === confirmNewPassword) {
                if (password === newPassword) {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Please Make Sure Your Current Password and New Password Are Different!" })
                    this.showErrorMessage("tr");
                } else {
                    if (newPassword.length < 8) {
                        this.setState({ loading: false });
                        this.setState({ errorMessage: "Please make sure Your new password is at least 8 characters long" })
                        this.showErrorMessage("tr");
                    } else {
                        const credential = {
                            username: username,
                            password: password,
                            newPassword: newPassword
                        };
                        this.authService.login(credential, location, locationString)
                            .then(res => {
                            })
                            .catch(err => {
                                if (err.response.status === 401) {
                                    this.setState({ redirectToReferrer: true, loading: false });
                                }
                            });
                    }
                }
            } else {
                this.setState({ loading: false });
                this.setState({ errorMessage: "Please fill in New Password Correctly!" })
                this.showErrorMessage("tr");
            }
        } else if (componentMode === 'signTermOfUse') {
            if (username !== "" && password !== "") {
                const credential = {
                    username: username,
                    password: password,
                    't&c': termSigned
                };
                this.authService.login(credential, location, locationString)
                    .then(res => {
                        this.setState({ redirectToReferrer: true, loading: false });
                    })
                    .catch(err => {
                        if (err.response.status === 403) {
                            if (err.response.data.code === 'AC03') {
                                this.setState({ redirectToReferrer: true, loading: false });
                            }
                        }
                    });
            }
        } else if (componentMode === 'signTermAndResetPassword') {
            if (!termSigned)
                this.setState({ redirectToReferrer: true, loading: false });
            else if (termSigned) {
                if (username !== "" && password !== "" && newPassword !== "" && confirmNewPassword !== "" && newPassword === confirmNewPassword) {
                    if (password === newPassword) {
                        this.setState({ loading: false });
                        this.setState({ errorMessage: "Please Make Sure Your Current Password and New Password Are Different!" })
                        this.showErrorMessage("tr");
                    } else {
                        if (newPassword.length < 8) {
                            this.setState({ loading: false });
                            this.setState({ errorMessage: "Please make sure Your new password is at least 8 characters long" })
                            this.showErrorMessage("tr");
                        } else {
                            const credential = {
                                username: username,
                                password: password,
                                newPassword: newPassword,
                                't&c': termSigned
                            };
                            this.authService.login(credential, location, locationString)
                                .then(res => {
                                    this.setState({ redirectToReferrer: true, loading: false });
                                });;
                        }
                    }
                } else {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Please fill in New Password Correctly!" })
                    this.showErrorMessage("tr");
                }
            }
        } else if (componentMode === 'forgotPassword') {
            if (username !== "") {
                let value = document.getElementById('grecaptcharesponse').value;
                if (value !== '') {
                    this.authService.forgotPassword(username, value, 'forgotPassword', location, locationString)
                        .then(res => {
                            this.setState({ loading: false, message: res.data.content ? res.data.content : 'Password Reset Request is Successfully Sent' });
                            this.showMessage("tr");
                        })
                        .catch(err => {
                            if (err.response.status === 429) {
                                this.setState({ loading: false, errorMessage: 'An unexpected error occurred. Please try again later.' });
                                this.showErrorMessage("tr");
                            } else if (err.response.status === 400) {
                                this.setState({ loading: false, errorMessage: 'Request is invalid. Please try again later.' });
                                this.showErrorMessage("tr");
                            } else if (err.response.status === 500) {
                                this.setState({ loading: false, errorMessage: 'Google reCaptcha unavailable at this time. Please try again later.' });
                                this.showErrorMessage("tr");
                            } else {
                                this.setState({ loading: false, errorMessage: err.response.data.content });
                                this.showErrorMessage("tr");
                            }
                        });
                }
                else {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Please complete the captcha!" })
                    this.showErrorMessage("tr");
                }
            } else {
                this.setState({ disableSubmitButton: true, loading: false });
                this.setState({ errorMessage: "Please fill in email!" })
                this.showErrorMessage("tr");
            }
        } else if (componentMode === 'resetForgottenPassword') {
            if (newPassword !== "" && confirmNewPassword !== "") {
                if (newPassword.length < 8) {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Please make sure Your new password is at least 8 characters long" })
                    this.showErrorMessage("tr");
                } else if (newPassword !== confirmNewPassword) {
                    this.setState({ loading: false });
                    this.setState({ errorMessage: "Passwords do not match" })
                    this.showErrorMessage("tr");
                } else {
                    this.authService.resetForgottenPassword(this.state.passwordResetToken, newPassword, location, locationString)
                        .then(res => {
                            if (res && res.data && res.data.content) {
                                this.setState({ changedForgottenPassword: true, loading: false, message: res.data.content ? res.data.content : 'Password Reset Request is Completed' });
                                setTimeout(() => {
                                    return window.location.replace('/');
                                }, 1500);
                            }
                        })
                        .catch(err => {
                            if (err.response.status === 429) {
                                this.setState({ loading: false, errorMessage: 'An unexpected error occurred. Please try again later.' });
                                this.showErrorMessage("tr");
                            } else {
                                this.setState({ changedForgottenPassword: false, loading: false, errorMessage: err.response.data.content });
                                this.showErrorMessage("tr");
                            }
                        });
                }
            } else {
                this.setState({ loading: false });
                this.setState({ errorMessage: "Please fill in New Password Correctly!" })
                this.showErrorMessage("tr");
            }
        }
        // this.props.dispatch(loginUserAction(credential));
    }
    onUsernameChange = (event) => {
        this.setState({ username: event.target.value });
    }
    onPasswordChange = (event) => {
        this.setState({ password: event.target.value });
    }
    onNewPasswordChange = (event) => {
        this.setState({ newPassword: event.target.value });
    }
    onConfirmNewPasswordChange = (event) => {
        this.setState({ confirmNewPassword: event.target.value });
    }
    onFormChange = (event) => {
        const { noNRIC } = this.state;
        if (event.target.id === 'fullname') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 4) 
                    this.setState({ [event.target.id]: name, fullnameError: true, fullnameSuccess: false });
                else
                    this.setState({ [event.target.id]: name, fullnameError: false, fullnameSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, fullnameError: false, fullnameSuccess: false });
        }
        else if (event.target.id === 'address') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressError: true, addressSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressError: false, addressSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressError: false, addressSuccess: false });
        }

        else if (event.target.id === 'addressCity') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressCityError: true, addressCitySuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressCityError: false, addressCitySuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressCityError: false, addressCitySuccess: false });
        }

        else if (event.target.id === 'addressState') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressStateError: true, addressStateSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressStateError: false, addressStateSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressStateError: false, addressStateSuccess: false });
        }

        else if (event.target.id === 'addressPost') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressPostError: true, addressPostSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressPostError: false, addressPostSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressPostError: false, addressPostSuccess: false });
        }
        else if (event.target.id === 'addressRes') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressResError: true, addressResSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressResError: false, addressResSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressResError: false, addressResSuccess: false });
        }

        else if (event.target.id === 'addressResCity') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressResCityError: true, addressResCitySuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressResCityError: false, addressResCitySuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressResCityError: false, addressResCitySuccess: false });
        }

        else if (event.target.id === 'addressResState') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressResStateError: true, addressResStateSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressResStateError: false, addressResStateSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressResStateError: false, addressResStateSuccess: false });
        }

        else if (event.target.id === 'addressResPost') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 2) 
                    this.setState({ [event.target.id]: name, addressResPostError: true, addressResPostSuccess: false });
                else
                    this.setState({ [event.target.id]: name, addressResPostError: false, addressResPostSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, addressResPostError: false, addressResPostSuccess: false });
        }
        else if (event.target.id === 'passport') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 6) 
                    this.setState({ [event.target.id]: name, passportError: true, passportSuccess: false });
                else
                    this.setState({ [event.target.id]: name, passportError: false, passportSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, passportError: false, passportSuccess: false });
        }
        else if (event.target.id === 'username') {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                let name = event.target.value.trim();
                locationString = this.generateString();
                if (name !== '') {
                    this.authService.checkUsername(name, location, locationString)
                        .then(res => {
                            if (res && res.data && !res.data.msg) {
                                let result = res.data;
                                if (result.validity) {
                                    if (result.availability)
                                        this.setState({ [event.target.id]: name, usernameSuccess: true, usernameError: false, usernameValidity: false });
                                    else
                                        this.setState({ [event.target.id]: name, usernameSuccess: false, usernameError: true, usernameValidity: false });
                                }
                                else
                                    this.setState({ [event.target.id]: name, usernameSuccess: false, usernameError: true, usernameValidity: true });
                            }
                        });
                }
                else
                    this.setState({ [event.target.id]: name, usernameSuccess: false, usernameError: false, usernameValidity: false });
            }, 1000);
        }
        else if (event.target.id === 'email') {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                let name = event.target.value.trim();
                locationString = this.generateString();
                if (name !== '') {
                    this.authService.checkUserEmail(name, location, locationString)
                        .then(res => {
                            if (res && res.data && !res.data.msg) {
                                let result = res.data;
                                if (result.validity) {
                                    if (result.availability)
                                        this.setState({ [event.target.id]: name, emailSuccess: true, emailError: false, emailValidity: false });
                                    else
                                        this.setState({ [event.target.id]: name, emailSuccess: false, emailError: true, emailValidity: false });
                                }
                                else
                                    this.setState({ [event.target.id]: name, emailSuccess: false, emailError: true, emailValidity: true });
                            }
                        });
                }
                else
                    this.setState({ [event.target.id]: name, emailSuccess: false, emailError: false, emailValidity: false });
            }, 1000);
        }
        else if (event.target.id === 'nricnumber') {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                let name = event.target.value.trim();
                locationString = this.generateString();
                if (name !== '') {
                    if (noNRIC) 
                        this.setState({ passport: name, nricnumberSuccess: false, nricnumberError: false });
                    else {
                        this.authService.checkNRICNumber(name, location, locationString)
                            .then(res => {
                                if (res && res.data && !res.data.msg) {
                                    let result = res.data;
                                    if (result.validity) {
                                        if (result.availability)
                                            this.setState({ [event.target.id]: name, nricnumberSuccess: true, nricnumberError: false, nricnumberValidity: false });
                                        else
                                            this.setState({ [event.target.id]: name, nricnumberSuccess: false, nricnumberError: true, nricnumberValidity: false });
                                    }
                                    else
                                        this.setState({ [event.target.id]: name, nricnumberSuccess: false, nricnumberError: true, nricnumberValidity: true });
                                }
                            });
                    }
                }
                else
                    this.setState({ [event.target.id]: name, nricnumberSuccess: false, nricnumberError: false });
            }, 1000);
        }
        else if (event.target.id === 'pass') {
            let name = event.target.value;
            if (name !== '') {
                if (name.length < 10) 
                    this.setState({ [event.target.id]: name, passwordError: true, passwordSuccess: false });
                else
                    this.setState({ [event.target.id]: name, passwordError: false, passwordSuccess: true }, () => {
                        const { pass, conpass } = this.state;
                        if (pass === conpass) 
                            this.setState({ conpasswordError: false, conpasswordSuccess: true });
                        else {
                            if (conpass && conpass !== '')
                                this.setState({ conpasswordError: true, conpasswordSuccess: false });
                        }
                    });
            }
            else
                this.setState({ [event.target.id]: name, passwordError: false, passwordSuccess: false });
        }
        else if (event.target.id === 'conpass') {
            let name = event.target.value;
            if (name !== '') {
                if (name !== this.state.pass) 
                    this.setState({ [event.target.id]: name, conpasswordError: true, conpasswordSuccess: false });
                else
                    this.setState({ [event.target.id]: name, conpasswordError: false, conpasswordSuccess: true });
            }
            else
                this.setState({ [event.target.id]: name, conpasswordError: false, conpasswordSuccess: false });
        }
        else 
            this.setState({ [event.target.id]: event.target.value });
    }
    showErrorMessage(place) {
        this.setState({ isErrorMessage: true });
        if (!this.state[place]) {
            var x = [];
            x[place] = true;
            this.setState(x);
            setTimeout(
                function () {
                    x[place] = false;
                    this.setState(x);
                }.bind(this),
                6000
            );
        }
    }
    showMessage(place) {
        this.setState({ isErrorMessage: false });
        if (!this.state[place]) {
            var x = [];
            x[place] = true;
            this.setState(x);
            setTimeout(
                function () {
                    x[place] = false;
                    this.setState(x);
                }.bind(this),
                6000
            );
        }
    }
    disableSubmitButton() {
        if (this.state.componentMode === 'login') {
            if (this.state.username !== '' && this.state.password !== '')
                this.setState({ disableSubmitButton: false });
            else
                this.setState({ disableSubmitButton: true });
        } else if (this.state.componentMode === 'changePassword' || this.state.componentMode === 'resetPassword' || this.state.componentMode === 'signTermAndResetPassword') {
            if (this.state.password !== '' && this.state.newPassword !== '' && this.state.confirmNewPassword !== '' && this.state.newPassword === this.state.confirmNewPassword)
                this.setState({ disableSubmitButton: false });
            else
                this.setState({ disableSubmitButton: true });
        } else if (this.state.componentMode === 'forgotPassword') {
            if (this.state.username !== '') {
                if (this.isEmailValidate())
                    this.setState({ disableSubmitButton: false });
                else
                    this.setState({ disableSubmitButton: true });
            } else
                this.setState({ disableSubmitButton: true });
        } else if (this.state.componentMode === 'resetForgottenPassword') {
            if (this.state.newPassword !== '' && this.state.confirmNewPassword !== '' && this.state.newPassword === this.state.confirmNewPassword)
                this.setState({ disableSubmitButton: false });
            else
                this.setState({ disableSubmitButton: true });
        } else if (this.state.componentMode === 'register') {
            let condition = this.state.termsOfUse && this.state.privacyTerms;
            if (condition) 
                this.setState({ disableSubmitButton: false });
            else
                this.setState({ disableSubmitButton: true });
        }
    }
    handleKillSession() {
        this.setState({ newSession: true }, () => this.login());
    }
    errorMessageOpen() {
        this.setState({ errorDialog: true });
    }
    errorMessageClose() {
        this.setState({ errorDialog: false });
    }
    isEmailValidate() {
        const { username } = this.state;
        if (this.state.componentMode === 'forgotPassword') {
            if (username && username !== '') {
                if (username.match(/^[-!#$%&'*+0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/))
                    return true;
                return false;
            } else
                return true;
        }
    }
    isPasswordValidate() {
    }
    generateString = () => {
        const length = 8;
        let result = '';
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        locationString = result;
    }
    handleStartDateChange = (date) => {
        let newdate = moment(date);
        this.setState({ dateOfBirth: newdate.isValid() ? date : null, dobError: newdate.isValid() ? false : true });
    }
    acceptTerms = (event) => {
        this.setState({ [event.target.name]: event.target.checked, tncAgreementError: false });
    }
    acceptPrivacy = (event) => {
        this.setState({ [event.target.name]: event.target.checked, tncAgreementError: false });
    }
    redirectPage = (name) => {
        window.open(name === 'terms' ? '/termsofuse' : '/privacy', '_blank');
    }
    handleChangeMulti = value => {
        this.setState({ passportCountry: value });
    }
    noNRICCheck = (event) => {
        const { noNRIC } = this.state;
        this.setState({ noNRIC: !noNRIC });
    }
    noAddressCheck = (event) => {
        const { sameAddress } = this.state;
        this.setState({ sameAddress: !sameAddress });
    }
    handleChangeData = (value, name) => {
        this.setState({ [name]: value, [name + 'Error']: false });
    }
    register(e) {
        if (e)
            e.preventDefault();
        const { fullname, usergender, nricnumber, passport, passportCountry, noNRIC } = this.state;
        if (fullname && fullname !== '') {
            if (usergender) {
                if (noNRIC) {
                    if (passport && passport !== '') {
                        if (passportCountry) {
                            this.registerAddress();
                        }
                        else 
                            this.setState({ passportCountryError: true, loading: false });
                    }
                    else 
                        this.setState({ passportError: true, loading: false });
                }
                else {
                    if (nricnumber && nricnumber !== '') {
                        this.registerAddress();
                    }
                    else 
                        this.setState({ nricnumberError: true, loading: false });
                }
            }
            else 
                this.setState({ usergenderError: true, loading: false });
        }
        else 
            this.setState({ fullnameError: true, loading: false });
    }
    registerAddress = () => {
        const { address, addressCity, addressState, addressPost, addressCountry, sameAddress,
                addressRes, addressResCity, addressResState, addressResPost, addressResCountry } = this.state;
        
        if (address && address !== '') {
            if (addressCity && addressCity !== '') {
                if (addressState && addressState !== '') {
                    if (addressPost && addressPost !== '') {
                        if (addressCountry && addressCountry !== '') {
                            if (sameAddress)
                                this.setState({ addressRes: address, addressResCity: addressCity, addressResState: addressState, addressResPost: addressPost, addressResCountry: addressCountry }, this.registerCon);
                            else {
                                if (addressRes && addressRes !== '') {
                                    if (addressResCity && addressResCity !== '') {
                                        if (addressResState && addressResState !== '') {
                                            if (addressResPost && addressResPost !== '') {
                                                if (addressResCountry && addressResCountry !== '') {
                                                    this.registerCon();
                                                }
                                                else 
                                                    this.setState({ addressResCountryError: true, loading: false });
                                            }
                                            else 
                                                this.setState({ addressResPostError: true, loading: false });
                                        }
                                        else 
                                            this.setState({ addressResStateError: true, loading: false });
                                    }
                                    else 
                                        this.setState({ addressResCityError: true, loading: false });
                                }
                                else 
                                    this.setState({ addressResError: true, loading: false });
                            }
                        }
                        else 
                            this.setState({ addressCountryError: true, loading: false });
                    }
                    else 
                        this.setState({ addressPostError: true, loading: false });
                }
                else 
                    this.setState({ addressStateError: true, loading: false });
            }
            else 
                this.setState({ addressCityError: true, loading: false });
        }
        else 
            this.setState({ addressError: true, loading: false });
    }
    registerCon = () => {
        const { cookies } = this.props;
        const { fullname, usergender, nricnumber, passport, passportCountry, termsOfUse, privacyTerms, 
                dateOfBirth, contact, contactError, incomeRange, username, email, pass, conpass, broker1,
                address, addressCity, addressState, addressPost, addressCountry, 
                addressRes, addressResCity, addressResState, addressResPost, addressResCountry 
        } = this.state;
        if (dateOfBirth) {
            if (contact && contact !== '' && !contactError) {
                if (incomeRange) {
                    if (username && username !== '') {
                        if (email && email !== '') {
                            if (pass && pass !== '') {
                                if (conpass && conpass !== '') {
                                    if (termsOfUse && privacyTerms) {
                                        this.generateString();
                                        let firstBroker = broker1 ? broker1.value : null;
                                        let dob = dateOfBirth ? moment(dateOfBirth).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                                        let phoneNum = contact.substring(1);
                                        let country = passportCountry ? passportCountry.value : null;
                                        this.authService.createNewUser(fullname, username, pass, usergender.value, email, phoneNum, dob, passport, country, nricnumber, incomeRange.value, firstBroker, 
                                            address, addressCity, addressState, addressPost, addressCountry.value, addressRes, addressResCity, addressResState, addressResPost, addressResCountry.value, location, locationString)
                                            .then(res => {
                                                if (res && res.data && res.data.msg) {
                                                    if (res.data.msg === 'new user created') {
                                                        // this.setState({ tr: true, isErrorMessage: false, message: "We'll send an email to " + email + " in 5 minutes. Please open it up to activate your account." })
                                                        this.generateString();
                                                        this.authService.sendEmailVerification(email, location, locationString)
                                                            .then(res => {
                                                                this.setState({ loading: true });
                                                                cookies.set("emailCode", btoa(email));
                                                                window.location.replace("/sendemailsuccess");
                                                            })
                                                    }
                                                }
                                                this.setState({ loading: false })
                                            });
                                    }
                                    else 
                                        this.setState({ tncAgreementError: true, loading: false });
                                }
                                else 
                                    this.setState({ conpasswordError: true, loading: false });
                            }
                            else 
                                this.setState({ passwordError: true, loading: false });
                        }
                        else 
                            this.setState({ emailError: true, loading: false });
                    }
                    else 
                        this.setState({ usernameError: true, loading: false });
                }
                else 
                    this.setState({ incomeRangeError: true, loading: false });
            }
            else 
                this.setState({ contactError: true, loading: false });
        }
        else 
            this.setState({ dobError: true, loading: false });
    }

    render() {
        const { classes, cookies } = this.props;
        const { redirectToReferrer, contact, passportCountry, allBroker, allIncomeRange, 
                broker1, incomeRange, addressCountry, addressResCountry } = this.state;
        
        if (redirectToReferrer === true) 
            return window.location.replace("/home");
        
        const form = classNames({
            [classes.form]: true,
            [classes.darkTheme]: cookies.get('themeColor') === 'dark',
        });
        const dateOfBirthContainer = classNames({
            [classes.dateOfBirthContainer]: true,
            [classes.darkDateOfBirthContainer]: cookies.get('themeColor') === 'dark',
        });
        const phoneClass = classNames({
            [classes.phoneLightTheme]: cookies.get('themeColor') === 'light',
            [classes.phoneDarkTheme]: cookies.get('themeColor') === 'dark',
            [classes.phoneSuccess]: this.state.contactSuccess
        });
        const helperText = classNames({
            [classes.helperText]: true,
            [classes.greenHelperText]: this.state.contactSuccess
        });
        const cardClasses = classNames({
            [classes[this.state.cardAnimaton]]: true,
            [classes.darkCard]: cookies.get('themeColor') === 'dark',
        });

        // const formControl = classNames({
        //     [classes.formControl]: true,
        //     [classes.darkFormControl]: cookies.get('themeColor') === 'dark'
        // });
        // const selectClass = classNames({
        //     [classes.selectClass]: true, 
        //     [classes.darkSelectClass]: cookies.get('themeColor') === 'dark'
        // });
        // const image = require("../../assets/img/MVector-transparent.png");
        const darkImage = require("../../assets/img/bizKyc_logo.png");

        const datePickerTheme = createMuiTheme({
            overrides: cookies.get('themeColor') === 'dark' ? {
                MuiInputLabel: {
                    root: {
                        color: "white"
                    },
                    shrink: {
                        fontSize: "14px",
                        marginTop: "4px"
                    }
                },
                MuiInputBase: {
                    input: {
                        color: "white"
                    }
                },
                MuiPickersBasePicker: {
                    pickerView: {
                        background: "#121212",
                        color: "white"
                    }
                },
                MuiPickersCalendarHeader: {
                    dayLabel: {
                        color: "rgba(255, 255, 255, 0.38)"
                    },
                    transitionContainer: {
                        color: "white"
                    },
                    iconButton: {
                        backgroundColor: "#121212",
                        color: "rgba(255, 255, 255, 0.54)",
                        disabled: {
                            color: "rgba(255, 255, 255, 0.26)"
                        }
                    },
                },
                MuiPickersDay: {
                    day: {
                        color: "rgba(255, 255, 255, 0.54)"
                    },
                    dayDisabled: {
                        color: "rgba(255, 255, 255, 0.38)",
                    },
                },
            } : {},
        });
        const customStyles = {
            control: (provided, state) => ({
                ...provided,
                backgroundColor: cookies.get('themeColor') === 'dark' ? '#121212' : 'white',
            }),
            menu: (provided, state) => ({
                ...provided,
                backgroundColor: cookies.get('themeColor') === 'dark' ? '#121212' : 'white',
            }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                    ...styles,
                    backgroundColor: isDisabled ? null
                                    : isSelected ? cookies.get('themeColor') === 'dark' ? 'white' : '#121212'
                                    : isFocused ? cookies.get('themeColor') === 'dark' ? 'white' : '#121212' : null,
                    color: isDisabled ? '#ccc'
                        : isSelected ? cookies.get('themeColor') === 'dark' ? 'black' : 'white'
                        : isFocused ? cookies.get('themeColor') === 'dark' ? "black" : "white" : cookies.get('themeColor') === 'dark' ? "white" : "black",
                    cursor: isDisabled ? 'not-allowed' : 'default',
                };
            },
            singleValue: (styles, { data }) => ({ 
                ...styles, 
                color: cookies.get('themeColor') === 'dark' ? 'white' : 'black'
            }),
        };
        const countryList = this.props.CountryCodeList.map(data => { 
            return {
                label: data.name,
                value: data.code
            }
        }).sort((a,b) => {
            if (a.label < b.label) return -1;
            else if (a.label > b.label) return 1;
            else return 0;
        });
        return (
            <div style={{ background: cookies.get('themeColor') === 'dark' ? "black" : "white", color: cookies.get('themeColor') === 'dark' ? "white" : "black" }}>
                <Header
                    color="white"
                    routes={["/home"]}
                    brand="DiBots Portal"
                    absolute
                    registerPage
                    image={darkImage}
                    darkImage={darkImage}
                    cookies={cookies}
                />
                <div className={classes.pageHeader}>
                    <div className={classes.container}>
                        <GridContainer justify="center" /* className={classes.gridContainer} */>
                            <GridItem xs={12} sm={12} md={5}>
                                <Card className={classes[this.state.cardAnimaton]}>
                                    {
                                        <form className={form} onSubmit={this.register}>
                                            {/* <CardHeader color="primary" className={classes.cardHeader}>
                                                <h4>Login</h4>
                                            </CardHeader> */}
                                            <CardBody>
                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%" }}>
                                                        <CustomInput
                                                            labelText={"Name As Per IC"}
                                                            id="fullname"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "text",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Person className={classes.inputIconsColor} />
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.fullnameError}
                                                            success={this.state.fullnameSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.fullnameError ? "Please enter your name as per IC" : ""}
                                                        />
                                                    </div>

                                                    {/* <div style={{ flex: "1 1 25%", margin: "20px auto auto 8px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple-gender"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple-gender',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Salutation'
                                                                options={[{label: "Mr", value: "mr"}, {label: "Mrs", value: "mrs"},
                                                                            {label: "Ms", value: "ms"}, {label: "Dr", value: "dr"},
                                                                            {label: "Prof", value: "prof"}, {label: "Dato", value: "dato"}]}
                                                                value={this.state.userSalutation}
                                                                onChange={(val) => this.handleChangeData(val, 'userSalutation')}
                                                            />
                                                        </NoSsr>
                                                        {this.state.userSalutationError && <div className={classes.normalErrorMsg}>Please select a salutation</div>}
                                                    </div> */}

                                                    <div style={{ flex: "1 1 50%", margin: "20px auto auto 8px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple-gender"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple-gender',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Gender'
                                                                options={[{label: "Male", value: "male"}, {label: "Female", value: "female"}]}
                                                                value={this.state.usergender}
                                                                onChange={(val) => this.handleChangeData(val, 'usergender')}
                                                            />
                                                        </NoSsr>
                                                        {this.state.usergenderError && <div className={classes.normalErrorMsg}>Please select your gender</div>}
                                                    </div>
                                                </div>

                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                        <CustomInput
                                                            labelText={"NRIC / Passport"}
                                                            id="nricnumber"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "text",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <AssignmentInd className={classes.inputIconsColor} />
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true,
                                                                // disabled: this.state.noNRIC
                                                            }}
                                                            error={this.state.nricnumberError}
                                                            success={this.state.nricnumberSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            // helperText={this.state.nricnumberError ? (this.state.nricnumber === '' ? "Please enter your NRIC number" : "Invalid NRIC number") : this.state.nricnumberSuccess ? "" : "Without hyphen/dash, eg: 900101011234"}
                                                            helperText={this.state.nricnumberError ? (this.state.nricnumberValidity ? "Invalid NRIC number" : 
                                                                        this.state.nricnumber === '' ? "Please enter your email" : "User NRIC number has been registered") : 
                                                                        this.state.nricnumberSuccess ? "" : "Without hyphen/dash, eg: 900101011234"}
                                                        />
                                                        {/* <div style={{ fontSize: "12px", cursor: "pointer", width: "fit-content" }} onClick={this.noNRICCheck}>
                                                            <Checkbox size="small" checked={this.state.noNRIC} style={{ color: cookies.get('themeColor') === 'dark' ? "white" : "black", padding: "4px 4px 4px 0px" }} /> For those without NRIC
                                                        </div> */}
                                                    </div>

                                                    <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <ThemeProvider theme={datePickerTheme}>
                                                                <KeyboardDatePicker
                                                                    variant="inline"
                                                                    format='dd/MM/yyyy'
                                                                    margin="normal"
                                                                    id="date-picker-inline-1"
                                                                    label="Date Of Birth"
                                                                    autoOk
                                                                    value={this.state.dateOfBirth}
                                                                    maxDate={new Date()}
                                                                    onChange={this.handleStartDateChange}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                    className={dateOfBirthContainer}
                                                                />
                                                            </ThemeProvider>
                                                        </MuiPickersUtilsProvider>
                                                        {this.state.dobError && <div className={classes.normalErrorMsg}>Please enter your date of birth</div>}
                                                    </div>
                                                </div>

                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%", margin: "auto", marginRight: "4px", fontSize: "12px", cursor: "pointer" }} onClick={this.noNRICCheck}>
                                                        <Checkbox size="small" checked={this.state.noNRIC} style={{ color: cookies.get('themeColor') === 'dark' ? "white" : "black", padding: "4px 4px 4px 0px" }} /> Check if passport
                                                        {/* <CustomInput
                                                            labelText={"Passport"}
                                                            id="passport"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "text",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <AssignmentInd className={classes.inputIconsColor} />
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.passportError}
                                                            success={this.state.passportSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.passportError ? "Please enter your passport number" : ""}
                                                        /> */}
                                                    </div>

                                                    {this.state.noNRIC ? <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Passport Country'
                                                                options={countryList}
                                                                value={passportCountry}
                                                                onChange={(val) => this.handleChangeData(val, "passportCountry")}
                                                            />
                                                        </NoSsr>
                                                        {this.state.passportCountryError && <div className={classes.normalErrorMsg}>Please specify your passport country</div>}
                                                    </div> : ""}
                                                </div>

                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                        <PhoneInput
                                                            inputComponent={ SmartInput }
                                                            placeholder="Enter phone number *"
                                                            value={ contact }
                                                            onChange={ value => this.setState({ contact: value }, () => {
                                                                if (this.state.contact !== null && this.state.contact !== undefined) {
                                                                    if (!isValidPhoneNumber(this.state.contact)) {
                                                                        this.setState({ contactError: true, contactValidity: false, contactSuccess: false });
                                                                    }
                                                                    else
                                                                        this.setState({ contactError: false, contactSuccess: false }, () => {
                                                                            this.generateString();
                                                                            this.authService.checkPhoneNumber(this.state.contact.substring(1), location, locationString)
                                                                                .then(res => {
                                                                                    if (res && res.data && !res.data.msg) {
                                                                                        let result = res.data;
                                                                                        if (result.availability)
                                                                                            this.setState({ contactValidity: false, contactSuccess: true });
                                                                                        else 
                                                                                            this.setState({ contactValidity: true, contactSuccess: false });
                                                                                    }
                                                                                });
                                                                        });
                                                                }
                                                                else 
                                                                    this.setState({ contactError: false, contactValidity: false, contactSuccess: false })
                                                            }) }
                                                            className={phoneClass}
                                                        />
                                                        {this.state.contactError ? (
                                                            <div className={classes.errorMsg}>{contact === null || contact === undefined ? "Please enter your contact number" : "Invalid contact number format, eg: +60 12 345 6789"}</div>) : this.state.contactValidity ? <div className={classes.errorMsg}>Phone number has been registered</div> : <div className={helperText}>eg: +60 12 345 6789</div>
                                                        }
                                                    </div>

                                                    <div style={{ flex: "1 1 50%", marginLeft: "4px", marginTop: "20px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple-income"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple-income',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Annual Income'
                                                                options={allIncomeRange}
                                                                value={incomeRange}
                                                                onChange={(val) => this.handleChangeData(val, 'incomeRange')}
                                                            />
                                                        </NoSsr>
                                                        {this.state.incomeRangeError && <div className={classes.normalErrorMsg}>Please specify your annual income</div>}
                                                    </div>
                                                </div>

                                                <Card className={cardClasses} style={{ margin: "30px 0px 0px", width: "100%" }}>
                                                    <CardHeader style={{ width: "fit-content", height: "fit-content", padding: "0px 15px", marginTop: "auto" }}>
                                                        <div>Address as per IC</div>
                                                    </CardHeader>
                                                    <CardBody style={{ padding: "0px 1.875rem 0.9375rem" }}>
                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"Apartment / Unit / Suite / Floor #"}
                                                                    id="address"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressError}
                                                                    success={this.state.addressSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressError ? "Please enter your address as per IC" : ""}
                                                                />
                                                            </div>

                                                            <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"City"}
                                                                    id="addressCity"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressCityError}
                                                                    success={this.state.addressCitySuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressCityError ? "Please enter your city as per IC" : ""}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"State"}
                                                                    id="addressState"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressStateError}
                                                                    success={this.state.addressStateSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressStateError ? "Please enter your state as per IC" : ""}
                                                                />
                                                            </div>

                                                            <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"Postal Code"}
                                                                    id="addressPost"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressPostError}
                                                                    success={this.state.addressPostSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressStateError ? "Please enter your postal code as per IC" : ""}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 100%", marginRight: "4px", marginTop: "40px" }}>
                                                                <NoSsr>
                                                                    <ReactSelect
                                                                        styles={customStyles}
                                                                        inputId="react-select-multiple"
                                                                        TextFieldProps={{
                                                                            InputLabelProps: {
                                                                                htmlFor: 'react-select-multiple',
                                                                                shrink: true,
                                                                            },
                                                                        }}
                                                                        placeholder='Country'
                                                                        options={countryList}
                                                                        value={addressCountry}
                                                                        onChange={(val) => this.handleChangeData(val, "addressCountry")}
                                                                    />
                                                                </NoSsr>
                                                                {this.state.addressCountryError && <div className={classes.normalErrorMsg}>Please enter your country as per IC</div>}
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>

                                                <div style={{ fontSize: "12px", cursor: "pointer" }} onClick={this.noAddressCheck}>
                                                    <Checkbox size="small" checked={this.state.sameAddress} style={{ color: cookies.get('themeColor') === 'dark' ? "white" : "black", padding: "4px 4px 4px 0px" }} /> Check if residential address is same with IC
                                                </div>

                                                {!this.state.sameAddress ? <Card className={cardClasses} style={{ margin: "30px 0px 0px", width: "100%" }}>
                                                    <CardHeader style={{ width: "fit-content", height: "fit-content", padding: "0px 15px", marginTop: "auto" }}>
                                                        <div>Residential Address</div>
                                                    </CardHeader>
                                                    <CardBody style={{ padding: "0px 1.875rem 0.9375rem" }}>
                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"Apartment / Unit / Suite / Floor #"}
                                                                    id="addressRes"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressResError}
                                                                    success={this.state.addressResSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressResError ? "Please enter your residential address" : ""}
                                                                />
                                                            </div>

                                                            <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"City"}
                                                                    id="addressResCity"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressResCityError}
                                                                    success={this.state.addressResCitySuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressResCityError ? "Please enter your city" : ""}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"State"}
                                                                    id="addressResState"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressResStateError}
                                                                    success={this.state.addressResStateSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressResStateError ? "Please enter your state" : ""}
                                                                />
                                                            </div>

                                                            <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                                <CustomInput
                                                                    labelText={"Postal Code"}
                                                                    id="addressResPost"
                                                                    required={true}
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "text",
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <Home className={classes.inputIconsColor} />
                                                                            </InputAdornment>
                                                                        ),
                                                                        onChange: this.onFormChange,
                                                                        required: true
                                                                    }}
                                                                    error={this.state.addressResPostError}
                                                                    success={this.state.addressResPostSuccess}
                                                                    white={cookies.get('themeColor') === 'dark' ? true : false}
                                                                    helperText={this.state.addressResStateError ? "Please enter your postal code" : ""}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div style={{ width: "100%", display: "inline-flex" }}>
                                                            <div style={{ flex: "1 1 100%", marginRight: "4px", marginTop: "40px" }}>
                                                                <NoSsr>
                                                                    <ReactSelect
                                                                        styles={customStyles}
                                                                        inputId="react-select-multiple"
                                                                        TextFieldProps={{
                                                                            InputLabelProps: {
                                                                                htmlFor: 'react-select-multiple',
                                                                                shrink: true,
                                                                            },
                                                                        }}
                                                                        placeholder='Country'
                                                                        options={countryList}
                                                                        value={addressResCountry}
                                                                        onChange={(val) => this.handleChangeData(val, "addressResCountry")}
                                                                    />
                                                                </NoSsr>
                                                                {this.state.passportCountryError && <div className={classes.normalErrorMsg}>Please enter your country</div>}
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card> : ""}

                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 100%", marginRight: "4px", marginTop: "40px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple-broker1"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple-broker1',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Broker'
                                                                options={allBroker}
                                                                value={broker1}
                                                                onChange={(val) => this.handleChangeData(val, 'broker1')}
                                                            />
                                                        </NoSsr>
                                                        <div className={classes.normalHelperText}>Please specify if any</div>
                                                    </div>

                                                    {/* <div style={{ flex: "1 1 50%", marginLeft: "4px", marginTop: "40px" }}>
                                                        <NoSsr>
                                                            <ReactSelect
                                                                styles={customStyles}
                                                                inputId="react-select-multiple-broker2"
                                                                TextFieldProps={{
                                                                    InputLabelProps: {
                                                                        htmlFor: 'react-select-multiple-broker2',
                                                                        shrink: true,
                                                                    },
                                                                }}
                                                                placeholder='Broker'
                                                                options={allBroker}
                                                                value={broker2}
                                                                onChange={(val) => this.handleChangeData(val, 'broker2')}
                                                            />
                                                        </NoSsr>
                                                        <div className={classes.normalHelperText}>Please specify if any</div>
                                                    </div> */}
                                                </div>

                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                        <CustomInput
                                                            labelText={"Username"}
                                                            id="username"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "text",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Person className={classes.inputIconsColor} />
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.usernameError}
                                                            success={this.state.usernameSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.usernameError ? (this.state.usernameValidity ? "Username can only contains lowercase and digits" : 
                                                                        this.state.username === '' ? "Please enter your username" : "Username has been taken") : 
                                                                        this.state.usernameSuccess ? "Username is available" : ""}
                                                        />
                                                    </div>

                                                    <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                        <CustomInput
                                                            labelText={"Email Address"}
                                                            id="email"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "text",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Email className={classes.inputIconsColor} />
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.emailError}
                                                            success={this.state.emailSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.emailError ? (this.state.emailValidity ? "Invalid email format" : 
                                                                        this.state.email === '' ? "Please enter your email" : "Email has been registered") : 
                                                                        this.state.emailSuccess ? "Email is available" : ""}
                                                        />
                                                    </div>
                                                </div>
                                                        
                                                <div style={{ width: "100%", display: "inline-flex" }}>
                                                    <div style={{ flex: "1 1 50%", marginRight: "4px" }}>
                                                        <CustomInput
                                                            labelText="Password"
                                                            id="pass"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "password",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Icon className={classes.inputIconsColor}>
                                                                            lock_outline
                                                                        </Icon>
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.passwordError}
                                                            success={this.state.passwordSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.passwordError ? (this.state.pass === '' ? "Please enter your password" : "Password must contains at least 10 characters") : ""}
                                                        />
                                                    </div>
                                                    <div style={{ flex: "1 1 50%", marginLeft: "4px" }}>
                                                        <CustomInput
                                                            labelText="Confirm Password"
                                                            id="conpass"
                                                            required={true}
                                                            formControlProps={{
                                                                fullWidth: true
                                                            }}
                                                            inputProps={{
                                                                type: "password",
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Icon className={classes.inputIconsColor}>
                                                                            lock_outline
                                                                        </Icon>
                                                                    </InputAdornment>
                                                                ),
                                                                onChange: this.onFormChange,
                                                                required: true
                                                            }}
                                                            error={this.state.conpasswordError}
                                                            success={this.state.conpasswordSuccess}
                                                            white={cookies.get('themeColor') === 'dark' ? true : false}
                                                            helperText={this.state.conpasswordError ? (this.state.conpass === '' ? "Please confirm your password" : "Password do not match") : ""}
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <FormGroup row>
                                                        <div style={{ display: "inline-grid" }}>
                                                            <div style={{ display: "inline-flex" }}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={this.state.termsOfUse} onChange={this.acceptTerms} name="termsOfUse" style={{ color: cookies.get('themeColor') === 'dark' ? "white" : "black" }} />}
                                                                    label="I have read and agree to the"
                                                                />
                                                                <div className={classes.agreementCheck} onClick={() => this.redirectPage('terms')}>Terms of Use</div>
                                                            </div>
                                                            <div style={{ display: "inline-flex" }}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={this.state.privacyTerms} onChange={this.acceptPrivacy} name="privacyTerms" style={{ color: cookies.get('themeColor') === 'dark' ? "white" : "black" }} />}
                                                                    label="I have read and agree to the"
                                                                />
                                                                <div className={classes.agreementCheck} onClick={() => this.redirectPage('privacy')}>Privacy Terms</div>
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    {this.state.tncAgreementError && <div className={classes.normalErrorMsg}>* Please read and accept the Terms of Use and Privacy Terms before register.</div>}
                                                </div>
                                            </CardBody>
                                            <CardFooter className={classes.cardFooter}>
                                                {

                                                    this.state.loading ?
                                                        (<CircularProgress className={classes.progress} />)
                                                        :
                                                        <Button disabled={this.state.disableSubmitButton} type="submit" color="blue" size="lg" onClick={this.register}>
                                                            {'Register'}
                                                        </Button>
                                                }
                                                {/* <input type="button" value="Pay with Payment Page" onclick="Checkout.showPaymentPage();" /> */}
                                            </CardFooter>
                                            <CustomSnackBar
                                                place="tr"
                                                color={this.state.isErrorMessage ? 'danger' : 'success'}
                                                message={this.state.isErrorMessage ? this.state.errorMessage : this.state.message}
                                                open={this.state.tr}
                                                closeNotification={() => this.setState({ tr: false })}
                                                close
                                                top80
                                            />
                                        </form>
                                    }
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(loginPageStyle)(RegisterPage);